import interceptorAxios from './InterceptorAxios';

const menuServices = {

    obtenerMenu(){
        return interceptorAxios.post('/menu/crear_menu.json');
    }
}

export default menuServices;